import React, { useState, useEffect, useRef, useMemo } from 'react';
import { createPortal } from 'react-dom'; // [NEW] Portal
import { ChevronRight, X } from 'lucide-react';
import AaronFace from './AaronFace'; // [NEW] Import AaronFace

// ... imports

export default function ProductTour({ onFinish, setActiveMenu, userProfile, onStepChange, tourTrigger }) { // [NEW] tourTrigger
    const [step, setStep] = useState(0);
    const [isVisible, setIsVisible] = useState(false); // Start hidden
    const [isReady, setIsReady] = useState(false); // [NEW] Wait for page load
    // ...
    const [isTypingComplete, setIsTypingComplete] = useState(false);
    const [spotlightStyle, setSpotlightStyle] = useState({});

    // [NEW] Delay tour start to ensure page is fully loaded
    useEffect(() => {
        const timer = setTimeout(() => {
            setIsReady(true);
            setIsVisible(true);
        }, 1500); // Wait 1.5 seconds for page to load
        return () => clearTimeout(timer);
    }, []);

    const steps = useMemo(() => [
        // 1. 환영 인사
        {
            menu: 'dashboard',
            title: "반가워요! 저는 아론이에요 👋",
            desc: "반가워요! 저는 <strong>아론</strong>이에요 👋<br/>사역의 든든한 파트너가 되어드릴게요.<br/><strong>The STAFF</strong>의 핵심 기능들, 제가 차근차근 안내해드릴게요!",
            action: null,
            overlay: true,
            targetId: null
        },
        // 2. 대시보드
        {
            menu: 'dashboard',
            title: "여기가 사역 본부에요 🏠",
            desc: "여기는 <strong>대시보드</strong>에요! 🏠<br/>오늘 할 일, 다가오는 일정, 중요한 알림까지.<br/>위젯을 드래그해서 나만의 공간으로 꾸며보세요!",
            action: null,
            overlay: false,
            targetId: null
        },
        // 3. 학생 명단
        {
            menu: 'students',
            title: "우리 아이들이 여기 있어요 📋",
            desc: "여기는 <strong>학생 명단</strong>이에요 📋<br/>이름, 연락처, 기도제목까지 한눈에!<br/>검색과 필터로 원하는 친구를 3초 만에 찾을 수 있어요.",
            action: null,
            overlay: false,
            targetId: null
        },
        // 4. 학생 등록 체험
        {
            menu: 'students',
            title: "새 친구 등록, 정말 쉬워요 ✨",
            desc: "새 친구 등록, 정말 쉬워요! ✨<br/>미리 입력해둔 예시 정보가 있어요.<br/><strong>'저장하기'</strong> 버튼을 눌러 직접 체험해보세요!",
            action: "demo_add_student",
            saveAction: "demo_save_student",
            position: 'right',
            overlay: false,
            targetId: "tour-student-modal"
        },
        // 5. 교사 명단
        {
            menu: 'teachers',
            title: "소중한 선생님들 👩‍🏫",
            desc: "여기는 <strong>교사 명단</strong>이에요 👩‍🏫<br/>선생님 정보 관리는 물론,<br/>회의록까지 기록하고 공유할 수 있어요.",
            action: null,
            overlay: true,
            targetId: "tour-teacher-card"
        },
        // 6. 교사 등록 체험
        {
            menu: 'teachers',
            title: "선생님도 등록해볼까요? 👋",
            desc: "선생님도 등록해볼까요? 👋<br/><strong>'저장하기'</strong>를 눌러주세요!<br/>새 선생님이 바로 명단에 추가된답니다.",
            action: "demo_add_teacher",
            saveAction: "demo_save_teacher",
            position: 'right',
            overlay: false,
            targetId: "tour-teacher-modal"
        },
        // 7. 출석부
        {
            menu: 'attendance',
            title: "출석 체크, 클릭 한 번! ✅",
            desc: "여기는 <strong>출석부</strong>에요 ✅<br/>매주 출석을 간편하게 기록하고,<br/>통계 그래프로 한눈에 확인하세요.",
            action: "demo_attendance",
            overlay: true,
            targetId: null
        },
        // 8. 심방 일지 (NEW)
        {
            menu: 'counseling',
            title: "심방 기록, 놓치지 마세요 💬",
            desc: "여기는 <strong>심방 일지</strong>에요 💬<br/>누구를 언제 만났는지, 무슨 이야길 나눴는지.<br/>소중한 목양의 발자취를 기록해보세요.",
            action: null,
            overlay: false,
            targetId: null
        },
        // 9. 캘린더 (NEW)
        {
            menu: 'schedule',
            title: "일정 관리도 한곳에서 📅",
            desc: "여기는 <strong>사역 캘린더</strong>에요 📅<br/>예배, 행사, 교사 모임까지!<br/>드래그 앤 드롭으로 일정을 쉽게 관리하세요.",
            action: null,
            overlay: false,
            targetId: null
        },
        // 10. 재정 관리 (NEW)
        {
            menu: 'finance',
            title: "투명한 재정 관리 💰",
            desc: "여기는 <strong>재정 관리</strong>에요 💰<br/>수입과 지출을 깔끔하게 기록하고,<br/>월별 리포트로 한눈에 확인하세요.",
            action: null,
            overlay: false,
            targetId: null
        },
        // 11. 아론 AI
        {
            menu: 'ai-assistant',
            title: "저 아론, 똑똑해요! 🤖",
            desc: "여기서 저 <strong>아론</strong>과 대화할 수 있어요 🤖<br/>데이터를 분석해서<br/>'오늘 이 친구 연락해보세요!' 라고 먼저 제안해드려요.",
            action: "demo_aaron",
            overlay: false,
            targetId: null
        },
        // 12. 통계
        {
            menu: 'statistics',
            title: "숫자로 보는 우리 부서 📊",
            desc: "여기는 <strong>사역 통계</strong>에요 📊<br/>출석률, 신앙 단계, 재정 현황까지.<br/>부서의 건강 상태를 한눈에 파악하세요.",
            position: 'bottom',
            overlay: false,
            targetId: "tour-stats-main"
        },
        // 13. 데이터 백업
        {
            menu: 'migration',
            title: "데이터, 안전하게 보관해요 💾",
            desc: "여기는 <strong>데이터 센터</strong>에요 💾<br/>클릭 한 번으로 백업 완료!<br/>소중한 사역 데이터를 잃어버릴 걱정 없어요.",
            position: 'bottom',
            overlay: false,
            targetId: "tour-backup-card"
        },
        // 14. 데이터 복구
        {
            menu: 'migration',
            title: "복구도 간단해요 🛡️",
            desc: "복구도 간단해요! 🛡️<br/>실수로 지워도 OK!<br/>백업 파일만 있으면 언제든 복구할 수 있어요.",
            position: 'bottom',
            overlay: false,
            targetId: "tour-restore-card"
        },
        // 15. 부서 & 팀 관리 (조직 관리) (NEW)
        {
            menu: 'dashboard',
            title: "부서 추가 & 팀 관리 ⛪",
            desc: "여기서 <strong>부서 추가 & 팀 관리</strong>를 할 수 있어요 ⛪<br/>여러 부서를 맡고 계신가요?<br/>'추가' 버튼으로 새 부서를 만들고,<br/>초대 코드로 선생님들을 초대해보세요!",
            position: 'left',
            overlay: false,
            targetId: "tour-dept-add-section",
            action: "demo_open_profile"
        },
        // 16. 부서 색상 테마 - No highlight
        {
            menu: 'dashboard',
            title: "부서마다 색을 입혀요 🎨",
            desc: "부서마다 <strong>테마 색상</strong>을 입혀요 🎨<br/>고유한 색상을 지정하면<br/>대시보드가 알록달록 예뻐져요!",
            position: 'left',
            overlay: false,
            targetId: null
        },
        // 17. 배지 시스템 - Opens Journey Modal
        {
            menu: 'dashboard',
            title: "🏆 숨겨진 배지를 모아보세요!",
            desc: "숨겨진 <strong>배지</strong>를 모아보세요! 🏆<br/>학생 10명 등록, 7일 연속 접속...<br/>사역하다 보면 깜짝 배지가 팝업될 거예요!",
            overlay: false,
            targetId: null,
            action: "demo_open_journey"
        },
        // 18. 마무리
        {
            menu: 'dashboard',
            title: "이제 시작해볼까요? 🚀",
            desc: "이제 시작해볼까요? 🚀<br/><strong>The STAFF</strong>와 함께라면<br/>사역이 더 스마트하고 은혜로워질 거예요.<br/>전도사님의 사역을 응원합니다! 💚",
            isLast: true,
            overlay: true,
            targetId: null
        }
    ], []);

    const currentStep = steps[step];

    // Effect: Handle Step Changes & Actions
    useEffect(() => {
        setIsTypingComplete(false); // Reset typing
        setSpotlightStyle({}); // Reset spotlight

        // 1. Menu Navigation
        if (currentStep.menu) {
            setActiveMenu(currentStep.menu);
        }

        // 2. Trigger Action (Delayed to ensure view is mounted/ready)
        if (onStepChange) {
            const timer = setTimeout(() => {
                onStepChange(currentStep.action || null);
            }, 50); // Small delay for React rendering cycle
            return () => clearTimeout(timer);
        }
    }, [step, setActiveMenu, onStepChange, currentStep]);

    // [NEW] Effect: Auto-advance when external trigger fires (e.g. Save Button Clicked)
    useEffect(() => {
        if (tourTrigger && tourTrigger > 0) {
            handleNext();
        }
    }, [tourTrigger]);

    // Effect: Calculate Spotlight Position with Retry & Resize Handling
    useEffect(() => {
        if (!currentStep.targetId) {
            setSpotlightStyle({});
            return;
        }

        const updateSpotlight = () => {
            const target = document.getElementById(currentStep.targetId);
            if (target) {
                // Ensure target is visible
                target.scrollIntoView({ behavior: 'smooth', block: 'center' });

                const rect = target.getBoundingClientRect();
                setSpotlightStyle({
                    top: rect.top - 10,
                    left: rect.left - 10,
                    width: rect.width + 20,
                    height: rect.height + 20,
                    opacity: 1
                });
                return true; // Found
            }
            return false; // Not found
        };

        // Try immediately
        if (isTypingComplete) {
            const found = updateSpotlight();

            // If not found, poll for it (handling view transitions)
            if (!found) {
                const intervalId = setInterval(() => {
                    if (updateSpotlight()) {
                        clearInterval(intervalId);
                    }
                }, 100); // Check every 100ms

                // Stop checking after 5 seconds to prevent memory leaks
                setTimeout(() => clearInterval(intervalId), 5000);

                return () => clearInterval(intervalId);
            }
        }
    }, [isTypingComplete, currentStep.targetId, step]); // Add step dependency

    // [NEW] Handle Window Resize to update spotlight
    useEffect(() => {
        const handleResize = () => {
            if (currentStep.targetId && isTypingComplete) {
                const target = document.getElementById(currentStep.targetId);
                if (target) {
                    const rect = target.getBoundingClientRect();
                    setSpotlightStyle({
                        top: rect.top - 10,
                        left: rect.left - 10,
                        width: rect.width + 20,
                        height: rect.height + 20,
                        opacity: 1
                    });
                }
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [currentStep.targetId, isTypingComplete]);

    const handleNext = () => {
        if (currentStep.saveAction && onStepChange) {
            onStepChange(currentStep.saveAction);
        }

        if (step < steps.length - 1) {
            setIsVisible(false);
            setTimeout(() => {
                setStep(prev => prev + 1);
                setIsVisible(true);
            }, 400);
        } else {
            handleFinish();
        }
    };

    const handleFinish = () => {
        setIsVisible(false);
        setTimeout(onFinish, 500);
    };

    const handleTypingComplete = React.useCallback(() => {
        setIsTypingComplete(true);
    }, []);

    // [NEW] Don't render until ready
    if (!isReady) return null;

    // [NEW] Use Portal to render outside of App root (on top of Modals)
    const tourContent = (
        <div className="fixed inset-0 z-[999999] pointer-events-none flex flex-col items-end justify-end pb-8 pr-8">

            {/* 2. Tour Card (Aaron Persona) */}
            <div className={`
                relative pointer-events-auto 
                w-[90%] max-w-lg rounded-[2rem] p-6 shadow-2xl
                transition-all duration-500 ease-out transform
                flex flex-col gap-4
                bg-white border-2 border-white
                ${currentStep.position === 'right' ? 'mr-12 mb-auto mt-auto' :
                    currentStep.position === 'top' ? 'mr-auto ml-auto mb-auto mt-24' : 'mb-4'}
                ${isVisible ? "translate-y-0 opacity-100 scale-100" : "translate-y-10 opacity-0 scale-95"}
            `}>

                {/* Header: Aaron's Avatar (Animated) */}
                <div className="flex items-center gap-4 border-b border-gray-100 pb-4">
                    <div className="w-16 h-16 rounded-full bg-gradient-to-br from-green-50 to-emerald-100 p-1 shadow-inner relative overflow-hidden flex items-center justify-center">
                        {/* [NEW] Use AaronFace Component */}
                        <AaronFace size={60} isTalking={!isTypingComplete} />
                    </div>
                    <div className="flex flex-col">
                        <span className="text-xs font-bold text-emerald-600 uppercase tracking-wider mb-0.5">AI Assistant</span>
                        <h2 className="text-2xl font-black text-gray-800 font-do-hyeon">Aaron (아론)</h2>
                    </div>
                    <div className="ml-auto flex items-center gap-3">
                        <span className="text-sm font-bold text-gray-400 bg-gray-100 px-3 py-1 rounded-full">
                            {step + 1} / {steps.length}
                        </span>
                        <button onClick={onFinish} className="text-gray-400 hover:text-gray-600 transition-colors p-2 hover:bg-gray-50 rounded-full">
                            <X size={20} />
                        </button>
                    </div>
                </div>

                {/* Content: Typewriter Text */}
                <div className="min-h-[80px]">
                    <div className="text-gray-600 font-medium leading-relaxed text-lg">
                        {/* Remount on step change to restart typing */}
                        {isVisible && (
                            <TypewriterHTML
                                content={currentStep.desc}
                                onComplete={handleTypingComplete}
                            />
                        )}
                    </div>
                </div>

                {/* Footer: Action Button */}
                <div className={`flex justify-end transition-all duration-500 delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"}`}>
                    <button
                        onClick={handleNext}
                        className="bg-[#1B3323] hover:bg-[#15281C] text-white px-8 py-3 rounded-xl font-bold text-lg shadow-lg flex items-center gap-2 transition-all hover:scale-105 active:scale-95"
                    >
                        {currentStep.isLast ? "시작하기" : "네, 알겠어요!"}
                        {!currentStep.isLast && <ChevronRight size={18} />}
                    </button>
                </div>
            </div>
        </div>
    );

    return createPortal(tourContent, document.body); // Render to Body
}
// Smart Typewriter for HTML
function TypewriterHTML({ content, onComplete }) {
    const [displayContent, setDisplayContent] = useState("");

    useEffect(() => {
        let currentString = "";
        let charIndex = 0;
        let isTag = false;
        let timeoutId = null;

        const typeChar = () => {
            if (charIndex >= content.length) {
                if (onComplete) onComplete();
                return;
            }

            const char = content[charIndex];

            if (char === '<') isTag = true;

            currentString += char;
            charIndex++;

            if (char === '>') isTag = false;

            if (isTag) {
                typeChar(); // Skip delay for tags
            } else {
                setDisplayContent(currentString);
                // Randomize speed slightly for realism users type 30-60ms
                timeoutId = setTimeout(typeChar, Math.random() * 20 + 30);
            }
        };

        timeoutId = setTimeout(typeChar, 100);
        return () => clearTimeout(timeoutId);
    }, [content, onComplete]);

    return <p dangerouslySetInnerHTML={{ __html: displayContent }} className="min-h-[3rem]" />;
}
